import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../components/Blog.css";
import {useLocation} from 'react-router-dom';
import { QRCodeCanvas } from "qrcode.react"; // Use QRCodeCanvas instead of QRCodeSVG


const BlogDetails = () => {

  const [qrType, setQrType] = useState("url");
  const [qrInput, setQrInput] = useState("");
  const [qrData, setQrData] = useState("");
  const location = useLocation();

  const [otherblogs, setOtherBlogs] = useState([]);

  // Fetch Blogs
  const fetchBlogs = async () => {
    try {
      const res = await fetch("reactapi/api/codeinputs/get_otherblogs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: location.pathname }),
      });
      const data = await res.json();
      setOtherBlogs(data.html || []);
      console.log(otherblogs.length);
    } catch (err) {
      console.error(err);
    }
  };

  // json viewer tool
  const generateQRCode = () => {
 if (!qrInput.trim()) {
      alert("Please enter valid information to generate the QR code.");
      return;
    }

    let formattedData;
    switch (qrType) {
      case "url":
        formattedData = qrInput;
        break;
      case "whatsapp":
        formattedData = `https://wa.me/${qrInput}`;
        break;
      case "text":
        formattedData = qrInput;
        break;
      case "email":
        formattedData = `mailto:${qrInput}`;
        break;
      default:
        formattedData = qrInput;
    }
    setQrData(formattedData);
  }

  const downloadQRCode = () => {
    const canvas = document.querySelector("canvas"); // Select the canvas element
    if (!canvas) {
      console.error("Canvas element not found");
      return;
    }
    const url = canvas.toDataURL("image/png"); // Convert canvas to data URL
    const a = document.createElement("a");
    a.href = url;
    a.download = "qrcode.png";
    a.click();
  };

  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Codeinputs - QR Code Generator
              </h1>
              <p>
                Published by <strong>Code Inputs</strong> • Complete Guide
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-8">
              <div className="blog-card">

              
        <p className="mt-4">QR codes are incredibly versatile tools that can enhance how you share information. Whether you need to link to a URL, encode text, share an email address, or even connect through WhatsApp, a QR code can simplify the process. If you're looking for a hassle-free way to generate these codes, consider using a free QR code generator on Google. These tools provide a free QR code generator with no sign-up required, making it easy to create and use QR codes instantly. Simply enter your desired content, and you'll have a scannable code ready to go, streamlining the way you connect and share information.</p>
            <Form>
              <Form.Group>
                <Form.Label>Select QR Code Type:</Form.Label>
                <Form.Control as="select" value={qrType} onChange={(e) => setQrType(e.target.value)}>
                  <option value="url">URL</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="text">Text</option>
                  <option value="email">Email</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mt-3">
                <Form.Label>Enter your information:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter URL, text, or email"
                  value={qrInput}
                  onChange={(e) => setQrInput(e.target.value)}
                />
              </Form.Group>
              <Button variant="primary" className="mt-3" onClick={generateQRCode}>
                Generate QR Code
              </Button>
            </Form>
            {qrData && (
              <div className="mt-4">
                <QRCodeCanvas value={qrData} size={200} /> {/* Use QRCodeCanvas */}
                <br />
                <Button variant="success" className="mt-3" onClick={downloadQRCode}>
                  Download QR Code
                </Button>
              </div>
            )}
          </div>
        </div>

             {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h4 className="sidebar-title">Other Blogs</h4>

                    {otherblogs.length === 0 ? (
                    <p className="text-muted">No blogs found</p>
                  ) : (
                    otherblogs.map((item, index) => (
                      <a
                        href={`/${item.route}`}
                        className="other-blog"
                        key={index}
                      >
                        <img
                          src={`/graphics/images/${item.image}`}
                          alt={item.title}
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <span>
                            {Math.floor(Math.random() * 10) + 1} min read
                          </span>
                        </div>
                      </a>
                    ))
                  )}

                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <a href="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
